/**
 * @(#)2019/7/11.
 * Certificates，用于输入证件：身份证、军官证或其他证
 * @author 许许
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import Basics from "../Basics";
import { cloneDeep } from "../../../utils";
import React, { Component } from "react";
import { l } from "../../../config/language";
import { YxComponent, Route, Connection } from "../../YxComponent";

/*
 *-----------------------证件输入框参数-------------------------------------------
 * @param type {string} 证件类型
 *         默认 identity，identity为身份证，passport为护照，military为军官证，police为警官证
 * @param styleParam {object} 样式参数
 * @param styleParam.width {object} 宽度  xxs,xs,sm,md,lg,xl
 * */

//默认props
let defaul = () => {
  return {
    type: "identity", //证件类型 identity/passport/military/police  身份证/护照/军官证/警官证
    inputParam: {}, //存给input的参数
    value: "",
    children: "",
    // 子节点
    rules: {},
    styleParam: {
      width: "sm", //宽度  xxs,xs,sm,md,lg,xl
      size: "default", //大小
      type: "default", //类型
    },
  };
};
@Connection(defaul)
class Certificates extends YxComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }
  productionHtml() {
    let tmpProps = this.props;
    tmpProps.rules = { ...tmpProps.rules };
    tmpProps.rules.legality = {
      //身份证
      //区位码校验、出生年月日校验（前正则限制起始年份为1900）、校验码判断
      identity: {
        pattern:
          /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
        message: l("Certificates.cm", this),
      },
      //护照
      // 规则： 14/15开头 + 7位数字, G + 8位数字, P + 7位数字, S/D + 7或8位数字,等
      // 样本： 141234567, G12345678, P1234567
      passport: {
        pattern: /^([a-zA-z]|[0-9]){5,17}$/,
        message: l("Certificates.pm", this),
      },
      //军官证
      // 规则： 军/兵/士/文/职/广/（其他中文） + "字第" + 4到8位字母或数字 + "号"
      // 样本： 军字第2001988号, 士字第P011816X号
      military: {
        pattern: /^[\u4E00-\u9FA5](字第)([0-9a-zA-Z]{4,8})(号?)$/,
        message: l("Certificates.jm", this),
      },
      //警官证
      police: {},
    }[tmpProps.type];

    let classParam = {
      yx_yxInput_: "styleParam.type",
      yx_yxInput_width_: "styleParam.width",
      yx_yxInput_size_: "styleParam.size",
    };
    tmpProps.inputParam.className = this.styleParamClassName(
      tmpProps,
      classParam
    );

    let html = Basics.html(tmpProps);
    return html;
  }
  render() {
    //合并默认参数和外部参数
    return this.productionHtml();
  }
}
export default Certificates;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/Certificates/certificates.js